import { BaseProgressionStrategy } from './BaseProgressionStrategy.js';

export class BreakcoreProgressionStrategy extends BaseProgressionStrategy {
  build(ctx) {
    if (ctx.scale.length >= 7) {
      const choice = this.pick(ctx, [[0, 5, 3, 4], [0, 0, 0, 0], [0, 1, 0, 1], [5, 4, 3, 0]]);
      return choice.map(deg => this.triad(ctx, deg));
    }
    return [this.triad(ctx, 0), this.triad(ctx, 3), this.triad(ctx, 0), this.triad(ctx, 4)];
  }
}
